module.exports = __webpack_public_path__ + "static/media/decoration-gray-bottom-1.e4f765df.svg";